import React from "react";
import { Link } from "react-router-dom";

export default function PortalFooter({ tenant, slug, primary }) {
  const b = tenant?.branding || {};
  const p = primary || b.primary_color || "#2A86A8";
  return (
    <footer className="mt-16 border-t border-black/5 bg-zinc-50" data-testid="portal-footer">
      <div className="max-w-6xl mx-auto px-6 py-10 grid md:grid-cols-4 gap-8 text-xs">
        <div>
          <div className="font-heading text-sm font-bold tracking-tight" style={{ color: p }}>{tenant?.name}</div>
          <div className="text-zinc-500 mt-1">{tenant?.city}</div>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-widest font-bold text-zinc-500 mb-2">Angebot</div>
          <ul className="space-y-1">
            <li><Link to={`/portal/${slug}/book`} className="text-zinc-600 hover:underline">Adresse prüfen</Link></li>
            <li><Link to={`/portal/${slug}/karte`} className="text-zinc-600 hover:underline">Interessenten-Karte</Link></li>
            <li><Link to={`/portal/${slug}/referenzen`} className="text-zinc-600 hover:underline">Referenzen</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-widest font-bold text-zinc-500 mb-2">Rechtliches</div>
          <ul className="space-y-1">
            <li><Link to={`/portal/${slug}/impressum`} className="text-zinc-600 hover:underline" data-testid="footer-impressum-link">Impressum</Link></li>
            <li><Link to={`/portal/${slug}/agb`} className="text-zinc-600 hover:underline" data-testid="footer-agb-link">AGB</Link></li>
            <li><Link to={`/portal/${slug}/datenschutz`} className="text-zinc-600 hover:underline" data-testid="footer-datenschutz-link">Datenschutz</Link></li>
          </ul>
        </div>
        <div className="text-right md:text-right">
          <div className="text-[10px] uppercase tracking-widest font-bold text-zinc-500 mb-2">Betrieb</div>
          <div className="text-zinc-500">Powered by</div>
          <Link to="/" className="font-heading text-lg font-bold tracking-tight hover:underline">Tonneva</Link>
        </div>
      </div>
    </footer>
  );
}
